export type SubscriptionPlan = 'free' | 'premium';

export interface SubscriptionLimits {
    maxCases: number;
    maxMembersPerCase: number;
    maxMedications: number; // Global limit per user/case context ? Actually per case makes more sense if we attach meds to cases.
    // But wait, the context logic is: if currentCase, use case meds. if not, use user meds.
    // The limit should probably apply to the *context* you are in.
}

export const SUBSCRIPTION_LIMITS: Record<SubscriptionPlan, SubscriptionLimits> = {
    free: {
        maxCases: 1,
        maxMembersPerCase: 2,
        maxMedications: 5,
    },
    premium: {
        maxCases: Infinity,
        maxMembersPerCase: Infinity,
        maxMedications: Infinity,
    },
};

export const getSubscriptionLimit = (plan: SubscriptionPlan | undefined, limitKey: keyof SubscriptionLimits): number => {
    const currentPlan = plan || 'free';
    return SUBSCRIPTION_LIMITS[currentPlan][limitKey];
};
